export const createBuildup = (buildup: string) => {
  try {
    BuildWallTypeEvent.raise(buildup);
  } catch (error) {
    console.error(error);
  }
};

export const openMaterialWindow = () => {
  try {
    ShowMaterialsEvent.raise("");
  } catch (error) {
    console.error(error);
  }
};

export const drawExistingWall = (modelNumber: string) => {
  try {
    BuildExistingWallEvent.raise(modelNumber);
  } catch (error) {
    console.error(error);
  }
};

export const openPdf = (url: string) => {
  try {
    Misc.openPdf(url);
  } catch (error) {
    console.error(error);
  }
};
